document.addEventListener('DOMContentLoaded', function () {
  var STORAGE_KEY = 'hbc_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function sync(button) {
    var id = button.getAttribute('data-product-id');
    var active = getWishlist().indexOf(id) !== -1;
    button.setAttribute('aria-pressed', String(active));
    button.classList.toggle('is-active', active);
    var labelEl = button.querySelector('[data-label]');
    if (labelEl) {
      labelEl.textContent = active
        ? button.getAttribute('data-label-added')
        : button.getAttribute('data-label');
    }
  }

  document.querySelectorAll('[data-hbc-wishlist-button]').forEach(function (button) {
    sync(button);
    button.addEventListener('click', function () {
      var id = button.getAttribute('data-product-id');
      var list = getWishlist();
      var index = list.indexOf(id);
      if (index === -1) {
        list.push(id);
      } else {
        list.splice(index, 1);
      }
      setWishlist(list);
      sync(button);
    });
  });
});
